// ชิ้นส่วนที่หน้าเช็คชื่อใช้ร่วมกัน — เช็คชื่อคาบเรียน (CheckAttendance) และเช็คขาดสอบ
// (examAbsence/ExamAbsenceCheck) ต้องหน้าตาเหมือนกัน ครูจะได้ไม่ต้องเรียนสองแบบ
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { leaveReportedByLabel } from "../utils/leaveSource";

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');
export const StudentAvatar = ({ photo, name, fill = false }) => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const initial = name ? name.trim().charAt(0) : '?';
  const src = photo ? `${UPLOAD_BASE}${photo.startsWith('/') ? photo : `/${photo}`}` : null;

  if (fill) {
    return (
      <>
        <div
          style={{ width: '100%', height: '100%', cursor: src ? 'pointer' : 'default' }}
          onClick={() => src && setShowModal(true)}
        >
          {src
            ? <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : <div style={{ width: '100%', height: '100%', backgroundColor: '#adb5bd', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 600 }}>{initial}</div>
          }
        </div>
        {src && (
          <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
            <Modal.Body className="p-3 text-center">
              <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
              {name && <div className="mt-2 fw-semibold small">{name}</div>}
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }

  const circleStyle = { width: 28, height: 28, borderRadius: '50%', flexShrink: 0 };
  return (
    <>
      <span
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
        onMouseEnter={() => src && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => src && setShowModal(true)}
      >
        {src
          ? <img src={src} alt="" style={{ ...circleStyle, objectFit: 'cover', cursor: 'pointer' }} />
          : <span style={{ ...circleStyle, backgroundColor: '#adb5bd', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initial}</span>
        }
        {src && hovered && (
          <div style={{ position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)', zIndex: 1050, background: '#fff', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.25)', padding: 4 }}>
            <img src={src} alt={name} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, display: 'block' }} />
          </div>
        )}
      </span>
      {src && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
          <Modal.Body className="p-3 text-center">
            <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
            {name && <div className="mt-2 fw-semibold small">{name}</div>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

// ป้ายกำกับเมื่อนักเรียนลาไว้ล่วงหน้า (ครูประจำชั้น/ฝ่ายปกครอง/หัวหน้าวิชาการแจ้งลา
// หรือมีใบอนุญาตกลับบ้านที่ครอบวันนี้)
export const LeaveBadge = ({ leave }) => {
  if (!leave) return null;
  if (leave.source === 'home_leave') {
    // returned_at = เวลาที่ยามกดว่ากลับเข้าโรงเรียนแล้ว — บอกครูว่าเด็กคนนี้กลับมาแล้ว
    // จะได้ไม่งงว่าทำไมมีใบกลับบ้านแต่ระบบไม่ตั้ง "ลา" ให้
    const back = leave.returned_at ? ` · กลับเข้า ${leave.returned_at.slice(11, 16)} น.` : '';
    return (
      <span className={`badge ${leave.is_active ? 'bg-info' : 'bg-secondary'} ms-2`} title={leave.leave_note || ''}>
        <i className="ri-home-heart-line me-1"></i>กลับบ้าน{leave.leave_note ? ` (${leave.leave_note})` : ''}{back}
      </span>
    );
  }
  const label = leave.leave_type === 'sick' ? 'ป่วย' : 'กิจ';
  const by = leaveReportedByLabel(leave.source);
  return (
    <span className="badge bg-info ms-2" title={leave.leave_note || ''}>
      <i className="ri-calendar-close-line me-1"></i>{by} ({label})
    </span>
  );
};

// ตรวจจับหน้าจอมือถือ (max-width: 768px)
export const useIsMobile = (query = '(max-width: 768px)') => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia(query).matches
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);
  return isMobile;
};
